import './index.scss';
import App from '##/App';

export default App;
